import { EventArgs } from 'react-ga';
import TagManager from 'react-gtm-module';

type Args = Pick<
  EventArgs,
  'category' | 'action' | 'label' | 'value' | 'nonInteraction'
>;

type Analytics = {
  track: (eventArgs: Args) => void;
};

export const useAnalytics = (): Analytics => {
  const track = (eventArgs: Args) => {
    TagManager.dataLayer({
      dataLayer: {
        event: eventArgs.action,
        ...eventArgs,
      },
    });
  };

  return {
    track,
  };
};
